import {Component} from '@angular/core';
import {AuthUserService} from "./@shared/services/auth/auth-user.service";
import {environment} from '../environments/environment';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public user$: any = this.authService.user$;
  public favIcon = document.querySelector('#appIcon') as HTMLLinkElement;

  constructor(private authService: AuthUserService,
              private titleService: Title
  ) {
    this.titleService.setTitle('Admin ' + environment.projectName);
    this.favIcon.href = `../assets/icons/${environment.projectName.toLowerCase()}.png`;
  }
}
